import ContentSection from "./ContentSection"

export default ContentSection
